import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { RepresentativeSimpleView } from 'domains/Representative/components'

const RepresentativeList = (props) => {
  const { representatives, isListWithCreate, listView, emptyProps, actions } =
    props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {representatives?.length > 0 ? (
        representatives?.map((representative, index) => (
          <Col
            mb={4}
            key={representative?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <RepresentativeSimpleView
              actions={actions}
              index={index}
              isSelected={representative?._id === selectedItem}
              onSelect={setSelectedItem}
              representative={representative}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message ||
              t('No representatives have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

RepresentativeList.propTypes = {
  representatives: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default RepresentativeList
